import React, { useEffect, useRef, useState } from 'react'
import { getValueFromResource } from '../../common/timeLiveFunction'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import { KTSVG } from '../../_metronic/helpers';
import { CurrentCultureDateFormat } from '../../common/UiUtilities';
import DatePicker from "react-datepicker";
import { CustomCalendarContainer } from '../../common/CustomCalendarContainer';
import fetchTimeliveAPI from '../../common/fetchTimeliveAPI';
import { RefreshScheduler, SaveAccountProjectMilestone, UpdateAccountProjectMilestone, UpdateShowMilestone } from './SchedulerSlice';
import moment from 'moment';
import { ShowToast } from '../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { getCustomPagePermissionsAsync } from '../../common/GlobalSlice';

interface AddUpdateMilestoneModalProps {
    onClose: () => void;
    editMilestone?: any;
    DateAndProject?: any;
    onMilestoneSaved?: (projectId: string) => void
}

const AddUpdateMilestoneModal = ({ onClose, editMilestone, DateAndProject, onMilestoneSaved }: AddUpdateMilestoneModalProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [milestoneName, setMilestoneName] = useState('');
    const [milestoneDate, setMilestoneDate] = useState(DateAndProject?.clickedDate ?? new Date());
    const { calendarStartDay , CurrentCultureDateFormat} = useAppSelector((state) => state.globalState)
    const endDateInputRef = useRef<HTMLInputElement>(null);
    const updateFlag = editMilestone?.types === 'milestone'
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const AccountId = localStorage.getItem('accountId');
    const projectId = editMilestone?.AccountProjectId ?? DateAndProject?.AccountProjectId;

    const getMilestoneData = async () => {
        try {
            const response = await fetchTimeliveAPI(`api/Milestone/GetAccountProjectMilestoneById/${editMilestone?.AccountProjectMilestoneId}`, 'GET', "", true);
            const result = await response.json();
            if (result.StatusCode == 200) {
                const data = result?.Data[0];
                setMilestoneName(data?.MilestoneDescription || '');
                const milestoneDt = data?.MilestoneDate ? new Date(data.MilestoneDate) : new Date();
                setMilestoneDate(milestoneDt);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (updateFlag) {
            getMilestoneData();
        } else if (DateAndProject) {
            setMilestoneDate(DateAndProject?.clickedDate);
        }
    }, [editMilestone, DateAndProject, updateFlag])

    const handleAddUpdateMilestone = async () => {
        if (updateFlag) {
            try {
                const payload = {
                    AccountId: AccountId,
                    ModifiedByEmployeeId: AccountEmployeeId,
                    AccountProjectMilestoneId: editMilestone?.AccountProjectMilestoneId,
                    MilestoneDescription: milestoneName,
                    MilestoneDate: moment(milestoneDate).format('YYYY-MM-DD'),
                    Comments: '',
                }
                const response = await dispatch(UpdateAccountProjectMilestone(payload))
                ShowToast('Success', response, "success", "toast-top-right");
                dispatch(UpdateShowMilestone(false))
                onMilestoneSaved?.(projectId);
                dispatch(RefreshScheduler(true))
                 dispatch(getCustomPagePermissionsAsync("30"))
            } catch (error) {
                console.log(error);
                ShowToast('Error', error, "error", "toast-top-right");
            }
        } else {
            try {
                const payload = {
                    AccountProjectId: DateAndProject?.AccountProjectId,
                    MilestoneDescription: milestoneName,
                    MilestoneDate: moment(milestoneDate).format('YYYY-MM-DD'),
                    AccountEmployeeId: AccountEmployeeId,
                    Comments: '',
                    AccountId: AccountId,
                    StartDate: moment(milestoneDate).format('YYYY-MM-DD'),

                }
                const response = await dispatch(SaveAccountProjectMilestone(payload))
                ShowToast('Success', response, "success", "toast-top-right");
                dispatch(UpdateShowMilestone(false))
                onMilestoneSaved?.(projectId);
                dispatch(RefreshScheduler(true))
                 dispatch(getCustomPagePermissionsAsync("30"))
            } catch (error) {
                console.log(error);
                ShowToast('Error', error, "error", "toast-top-right");
            }
        }
    }

    const handleDelete = async () => {
        try {
            const resultConfirm = await ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", 'Yes delete it!', 'custom-swal-container');
            if (!resultConfirm) return;
            const response = await fetchTimeliveAPI(`api/Milestone/${editMilestone?.AccountProjectMilestoneId}`, 'DELETE', '', true);
            const result = await response.json();
            if (result?.StatusCode === '200') {
                ShowToast('Success', result?.ResponseMessage, "success", "toast-top-right");
                dispatch(UpdateShowMilestone(false))
                dispatch(RefreshScheduler(true))
                onMilestoneSaved?.(projectId);
            } else {
                ShowToast('Error', result?.ResponseMessage, "error", "toast-top-right");
            }
        } catch (error) {
            console.log(error);
            ShowToast('Error', error, "error", "toast-top-right");
        }
    }
    return (
        <div className='card-body'>
            <div className="modal drawer-overlay" style={{ display: 'block' }}>
                <div className="modal-dialog" style={{ maxWidth: '500px' }}>
                    <div className="modal-content" style={{ maxHeight: '80vh' }}>
                        <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem' }}>
                            <div className="d-flex align-items-center gap-2">
                                <h5 className="modal-title mainHeading">{getValueFromResource(`${updateFlag ? 'Edit Milestone' : 'Add Milestone'}`, dispatch, t)}</h5>
                                {/* {updateFlag && <i className="bi bi-trash fs-5 delete-menu-icon-color allign cursor-pointer"
                                    data-tooltip-id="scheduler-event-tooltip"
                                    data-tooltip-content={getValueFromResource('Delete', dispatch, t)}
                                    onClick={handleDelete}
                                ></i>} */}
                            </div>
                            <div className="btn btn-icon btn-sm btn-active-secondary" onClick={onClose}>
                                <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                            </div>
                        </div>
                        <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }}>
                            <div className="">
                                <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Name', dispatch, t)}</label>
                                <input
                                    type="text"
                                    className="form-control fs-7 fw-normal pe-5"
                                    value={milestoneName}
                                    onChange={(e) => setMilestoneName(e.target.value)}
                                />
                            </div>
                            <div className="my-2">
                                <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Due Date', dispatch, t)}</label>
                                <div className="wrapper">
                                    <DatePicker
                                        selected={milestoneDate}
                                        onChange={(date) => setMilestoneDate(date as Date)}
                                        calendarStartDay={calendarStartDay}
                                        className="form-control"
                                        dateFormat={CurrentCultureDateFormat.toString()}
                                        popperContainer={({ children }) => (
                                            <CustomCalendarContainer inputRef={endDateInputRef}>
                                                {children}
                                            </CustomCalendarContainer>
                                        )}
                                    />
                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary btn-sm" onClick={onClose}>
                                {getValueFromResource('Cancel', dispatch, t)}
                            </button>
                            <button className="btn btn-primary btn-sm" onClick={handleAddUpdateMilestone}>
                                {getValueFromResource('Save', dispatch, t)}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddUpdateMilestoneModal